import { useContext } from 'react';
import { ColorModeContext } from '@/stores/ColorModeContext';

const useColorMode = () => {
  return useContext(ColorModeContext);
};

export default useColorMode;
